const stylePlugin = {
    install(app, options) {
        app.config.globalProperties.$bgColor = (color) => {
            return {
                backgroundColor: color,
                borderColor: color
            }
        };
        app.config.globalProperties.$bgGradient = (primary, secondary) => {
            return {
                background: `linear-gradient(87deg, ${primary} 0, ${secondary} 100%) !important`
            }
        };
    }
}

export default stylePlugin